import React from "react";
// import FanTech from "/images/fan_tech.png";
import { ReactComponent as FanTechLogo } from "assets/icons/fantech-logo.svg";
import { ReactComponent as Book } from "assets/icons/book-ico.svg";
import { ReactComponent as Twitter } from "assets/icons/twitter.svg";

import { isBrowser, isIOS } from "react-device-detect";
export const LandingPage: React.FC = () => (
  <>
    <div
      id="ft-hero"
      className="py-12 lg:py-48 h-full flex items-center relative z-20"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-0">
        <div className="flex items-center justify-center">
          <div className="flex-1 text-center lg:text-left lg:w-96">
            <div className="flex justify-center lg:justify-start mb-6">
              <a href="https://fan.tech" title="Fan.Tech">
                <FanTechLogo />
              </a>
            </div>
            <div className="text-3xl md:text-6xl font-bold mt-0 inline-block mb-4">
              <h1 className="inline-flex flex-col relative !leading-tight">
                <span>Fan Service, Redefined</span>
              </h1>
            </div>
            {isBrowser ? (
              <p className="text-lg md:text-xl w-100 lg:w-2/3 !leading-relaxed">
                Visit 😍<span className="text-cyan-400 font-bold">Fan</span>
                <span className="text-pink-500 font-bold">.tech</span> on a
                phone to install the app.
              </p>
            ) : (
              <div className="mb-8 font-mono flex justify-center lg:justify-start mt-4">
                <div className="bg-white bg-opacity-20 backdrop-blur py-2 px-4 rounded-lg flex flex-col gap-1">
                  <div className="flex items-center gap-3">
                    <span className="bg-pink-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center font-bold">
                      1
                    </span>
                    <span className="flex items-center gap-2">
                      Click{" "}
                      {isIOS ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-box-arrow-up"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z"
                          />
                        </svg>
                      ) : (
                        <i className="fa-regular fa-ellipsis-vertical" />
                      )}
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="bg-pink-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center font-bold">
                      2
                    </span>
                    Scroll down
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="bg-pink-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center font-bold">
                      3
                    </span>
                    {isIOS ? "Add to home screen" : "Install app"} 👏
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="hidden lg:flex max-w-[667px]">
            <img
              className="max-w-full"
              src={"/images/fantech_cover.png"}
              alt="Fan.tech - Fan Service, Redefined."
            />
          </div>
        </div>
      </div>
    </div>

    <div className="text-center absolute left-0 right-0 bottom-0 z-20 mb-4 text-sm">
      <div className="flex item-center justify-center gap-4 mb-8">
        <a href="https://docs.fan.tech/" title="Docs" target="blank">
          <Book className="w-4" />
        </a>
        <a
          href="https://twitter.com/joinfantech"
          title="Fan.tech"
          target="blank"
        >
          <Twitter className="w-8" />
        </a>
      </div>
      &copy; 2023 <span className="font-bold text-cyan-400">Fan</span>
      <span className="font-bold text-pink-500">.tech</span>
    </div>
  </>
);
